import { Wrapper, P } from "./style";

export const Licence = ({ licenceImage = null, textLink = null }) => {
  const LicenceImage = licenceImage;
  const TextLink = textLink;
  return (
    <Wrapper>
      {licenceImage && LicenceImage}
      <P>{textLink && TextLink}</P>
    </Wrapper>
  );
};
export default Licence;
